import { CHANNEL_TYPE } from 'gcs-common/helper/channelTypeHelper';
import FEATURE_FLAGS from 'gcs-common/helper/featureFlagsHelper';
import { getChannelType, getMemberCraftsmenCountForChannel } from 'gcs-common/slices/channel/channelSelectors';
import debounce from 'lodash-es/debounce';
import { replaceWithEmoji } from '../../../helper/emojiService';
import setChannelMessagesConsumed from '../../channel/channelThunks/setChannelMessagesConsumed';
import { getHasFeatureFlag, getIsAgent } from '../../currentUser/currentUserSelectors';
import { getMyMember } from '../../members/membersSelectors';
import { latestMessageIsRead } from '../../messages/messageSelector';
import { channelInputTextChanged, etsMessageTicketPartTextChanged } from '../messageInputSlice';

const debouncedSetChannelMessagesConsumed = debounce(
  (dispatch, channelId) => {
    dispatch(setChannelMessagesConsumed({ channelId }));
  },
  1000, // debounce delay in ms
  { leading: true, trailing: false },
);

export const changeInputText =
  ({ channelId, inputText, append = false }) =>
  async (dispatch, getState) => {
    const textWithEmojis = replaceWithEmoji(inputText);
    const latestIsRead = latestMessageIsRead(channelId)(getState());
    const isAgent = getIsAgent(getState());
    const markAsReadEnabled = getHasFeatureFlag(FEATURE_FLAGS.MARK_READ_ENABLED)(getState());
    const craftsmenCountForChannel = getMemberCraftsmenCountForChannel(channelId)(getState());
    const channelType = getChannelType(channelId)(getState());
    const myMemberUnreadCount = getMyMember(channelId)(getState())?.unreadCount ?? 0;
    const isDirectChatWithoutCraftsman = channelType === CHANNEL_TYPE.DIRECT_CHAT && craftsmenCountForChannel === 0;
    const isInternalChannel =
      channelType === CHANNEL_TYPE.INTERNAL_AGENT || channelType === CHANNEL_TYPE.INTERNAL_CRAFTSMAN;

    dispatch(channelInputTextChanged({ channelId, text: textWithEmojis, append }));

    // if markread feature flag is enabled typing should not trigger a read
    if (
      markAsReadEnabled &&
      channelType !== CHANNEL_TYPE.INTERNAL_AGENT &&
      channelType !== CHANNEL_TYPE.INTERNAL_CRAFTSMAN &&
      !isDirectChatWithoutCraftsman
    ) {
      return;
    }

    if (isAgent && (!latestIsRead || (isInternalChannel && myMemberUnreadCount > 0))) {
      debouncedSetChannelMessagesConsumed(dispatch, channelId);
    }
  };

export const changeInputTextForEtsMessage =
  ({ inputText, append = false }) =>
  async (dispatch) => {
    const textWithEmojis = replaceWithEmoji(inputText);
    dispatch(etsMessageTicketPartTextChanged({ text: textWithEmojis, append }));
  };
